import { call, put } from 'redux-saga/effects';

import {GET_QR_CODE_SUCCESS,GET_QR_CODE_FAILURE} from 'src/common/redux/actions/constants'; 
import axios from 'src/api/Api';

// API call function
export const getQRCodeAPI = (payload) => {
     const url = `occ/v2/${localStorage.getItem('baseSiteId')}/torqueApi/getTorqueUrl?myCaseRef=${payload.myCaseRef}`;
     return axios.get(`${url}`, payload); 
};

export function* getQRCodeSaga(action) {
    try {
        const response = yield call(getQRCodeAPI, action.payload);
        if (response?.data) {
            yield put({
                type: GET_QR_CODE_SUCCESS,
                payload: {
                    ...response.data,
                },
            });
        } else {
            yield put({
                type: GET_QR_CODE_FAILURE,
                payload: 'Failed to fetch QR code',
            });
        }
    } catch (error) {
        yield put({
            type: GET_QR_CODE_FAILURE,
            payload: error?.message || 'Failed to fetch QR code',
        });
    }
}
